import Btn from '../Btn/index'
import Toast from '../Toast/index'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'TransactionsDetail',
  components: { Btn, Toast },
  props: ["status", "calledIn"],
  data () {
    return {
      showBrekUp: false,
      back: undefined
    }
  },
  computed: {
    ...mapGetters([
      "activeTransaction"
    ])
  },
  mounted () {
    if (!this.activeTransaction) {
      this.setActiveTransaction(JSON.parse(localStorage.getItem('activeTxn')))
    }
    this.back = localStorage.getItem("from")
    localStorage.removeItem("from")
    localStorage.removeItem("paymentQuery")

  },
  methods: {

    setActiveTransaction (txn) {
      // localStorage.setItem('activeTransaction', JSON.stringify(txn))
      this.$store.dispatch('activeTransaction', txn)
    },
    goToPayments () {
      var txnString = this.activeTransaction.id;
      var txnAmount = this.activeTransaction.netPayableAmount;
      this.query = {
        txnIds: [txnString + ''],
        couponIds: [],
        productFlow: 'generic',
        deviceType: 'WEB'
      }
      localStorage.setItem("paymentQuery", JSON.stringify(this.query))
      localStorage.setItem("txnAmount", txnAmount);
      localStorage.setItem("txnString", txnString);
      this.$router.push({ name: 'PaymentType' });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/TransactionsDetail/component.js